import React, { memo } from "react";
import { css, cx } from "@emotion/css";
import { dropDownArrowWrapperStyle, dropDownArrowItemStyle, } from "../../../styles";
const DropDownArrow = ({ dropDownArrowWrapperStyleFn, dropDownArrowItemStyleFn, openMenu, }) => {
    return (React.createElement("div", { className: cx("react-auto-scroll-time-select__drop-down-arrow-wrapper", css(dropDownArrowWrapperStyleFn
            ? dropDownArrowWrapperStyleFn(dropDownArrowWrapperStyle)
            : dropDownArrowWrapperStyle)), onClick: openMenu },
        React.createElement("div", { className: cx("react-auto-scroll-time-select__drop-down-arrow-item", css(dropDownArrowItemStyleFn
                ? dropDownArrowItemStyleFn(dropDownArrowItemStyle)
                : dropDownArrowItemStyle)) })));
};
export default memo(DropDownArrow);
